import { FormikProps, useFormikContext } from 'formik'
import { useStyles } from '../../Plan.styles'
import {
  RadioButtonGroupMapping,
  RadioButtonsV2,
  RadioButtonType,
} from '@labrav/react-components'
import {
  AzureOfferPlan,
  BillingTerm,
  Installments,
  PaymentOption,
  ScheduleType,
} from '../../../../../modules/privateOffer/reducer'
import { cloneDeep } from 'lodash'
import { getInstallmentsBasedOnSchedule } from '../../../../../utils/resaleAuthorizationUtil'
import { getDiscountedPriceValue } from '../../../../../../common/utils/getDiscountedPriceValue'

export const getPaymentOptionDisplayValue = (
  billingTerm: BillingTerm,
  paymentOption: PaymentOption
) => {
  const billingTypeValue = billingTerm.type
  const paymentTypeValue = paymentOption.type
  if (billingTypeValue === 'month') {
    if (
      paymentTypeValue === 'month' ||
      (billingTerm?.value === 1 && billingTerm?.type === 'month')
    ) {
      return 'One time'
    }
  } else if (billingTypeValue === 'year') {
    if (paymentTypeValue === 'month') {
      return 'Per month'
    } else if (paymentTypeValue === 'year') {
      if (billingTerm?.value === 1 && paymentOption?.value === 1) {
        return 'One time'
      }
      return 'Per year'
    }
  }
  return ''
}
export const PaymentType = ({
  plan,
  index,
  durationInMonths,
  selectedPaymentOptionValue,
}: {
  plan: AzureOfferPlan
  index: number
  durationInMonths: number
  selectedPaymentOptionValue: string
}) => {
  const { classes } = useStyles()
  const { values, setFieldValue } = useFormikContext() as FormikProps<
    Record<string, unknown>
  >
  const isRatePerUser =
    plan?.originalPricing?.recurrentPrice?.recurrentPriceMode === 'perUser'

  const billingTerm = plan?.pricing.recurrentPrice?.prices[0]?.billingTerm
  const paymentOption = plan?.pricing?.recurrentPrice?.prices[0]?.paymentOption

  const paymentOptionValue = getPaymentOptionDisplayValue(
    billingTerm,
    paymentOption
  )
  const paymentTypeMapping: RadioButtonGroupMapping[] = [
    {
      key: paymentOptionValue || '',
      label: paymentOptionValue || '',
      type: RadioButtonType.STANDARD,
    },
    {
      key: 'flexiblePayment',
      label: 'Flexible schedule',
      type: RadioButtonType.STANDARD,
      disabled: durationInMonths === 1 || isRatePerUser,
      disabledTooltip:
        durationInMonths === 1 || isRatePerUser
          ? 'This option is not available for selected plan'
          : '',
    },
  ]

  const handleChangePaymentType = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event?.target?.value

    if (value) {
      const selectedPricingPrices = plan?.pricing?.recurrentPrice?.prices
      const originalPricingPrices =
        plan?.originalPricing?.recurrentPrice?.prices?.filter(
          item =>
            item?.billingTerm?.type ===
              selectedPricingPrices[0].billingTerm.type &&
            item?.billingTerm?.value ===
              selectedPricingPrices[0].billingTerm.value
        ) || []
      const updatePlanRow = {
        ...plan,
        pricing: {
          ...plan.pricing,
          recurrentPrice: {
            ...plan.pricing.recurrentPrice,
            prices: [
              {
                ...plan.pricing.recurrentPrice?.prices[0],
                ...(value === paymentOptionValue
                  ? {
                      pricePerPaymentInUsd: getDiscountedPriceValue({
                        price:
                          originalPricingPrices[0].pricePerPaymentInUsd || 0,
                        discount: plan?.discountPercentage,
                      }),
                      installments: undefined,
                    }
                  : {}),
                ...(value === 'flexiblePayment'
                  ? {
                      installments: {
                        frequency: ScheduleType.MONTHLY,
                        tcv: getDiscountedPriceValue({
                          price:
                            originalPricingPrices[0].pricePerPaymentInUsd || 0,
                          discount: plan?.discountPercentage,
                        }),
                        schedule: getInstallmentsBasedOnSchedule({
                          tcv: getDiscountedPriceValue({
                            price:
                              originalPricingPrices[0].pricePerPaymentInUsd ||
                              0,
                            discount: plan?.discountPercentage,
                          }),
                          durationInMonths: durationInMonths || 0,
                          paymentSchedule: ScheduleType.MONTHLY,
                          now: (values?.offerStartDate as string) || '',
                        }) as unknown as Installments[],
                      },
                      pricePerPaymentInUsd: undefined,
                    }
                  : {}),
              },
            ],
          },
        },
      }
      const plans = [...(values.plans as AzureOfferPlan[])]
      plans[index] = {
        ...cloneDeep(updatePlanRow),
      }
      setFieldValue('plans', [...cloneDeep(plans)])
    } else {
      setFieldValue('plans', [...cloneDeep(values.plans as AzureOfferPlan[])])
    }
  }

  return (
    <div>
      <div className={classes.widthRadio}>
        <RadioButtonsV2
          checkedValue={{
            key: selectedPaymentOptionValue,
            value: selectedPaymentOptionValue,
          }}
          handleChange={handleChangePaymentType}
          radioButtonMappings={paymentTypeMapping}
        />
      </div>
    </div>
  )
}
